import {history} from "../store/index";
import {store} from "../../NextApp";
import {generateQueryString} from "../../util/Api";

import {
  CLEAR_MANPOWER_PERFORMANCE_REPORT_DATA,
  CLEAR_MANPOWER_PERFORMANCE_SUCCESS,
  CREATE_MANPOWER_PERFORMANCE_SUCCESS,
  FETCH_MANPOWER_PERFORMANCE_REPORT_DATA_SUCCESS,
  FETCH_MANPOWER_PERFORMANCE_SUCCESS,
  GET_JOB_CARD_BY_LOCATION_SUCCESS,
  GET_JOB_CARD_STATUS_BY_ACTIVITY_ID,
  GET_MANPOWER_PERFORMANCE_SUCCESS,
  SAVE_MANPOWER_PERFORMANCE_QUERY
} from "../../constants/ActionTypes";

import axios from "util/Api";
import {fetchError, fetchStart, fetchSuccess} from "./Common";
import {getUser} from "./Auth";
import {message} from "antd";
import {arrayToCSV, downloadCSV} from "../../util/methods";

export const getResourceSuccess = ({data, count}) => {
  return {
    type: GET_MANPOWER_PERFORMANCE_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = query => {
  return {
    type: SAVE_MANPOWER_PERFORMANCE_QUERY,
    query
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_MANPOWER_PERFORMANCE_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({data}) => {
  return {
    type: FETCH_MANPOWER_PERFORMANCE_SUCCESS,
    data
  };
};

export const getJobCardByLocationSuccess = ({data}) => {
  return {
    type: GET_JOB_CARD_BY_LOCATION_SUCCESS,
    data
  };
};

export const getJobCardStatusByActivityIdSuccess = ({data}) => {
  return {
    type: GET_JOB_CARD_STATUS_BY_ACTIVITY_ID,
    data
  };
};

export const clearData = () => {
  return {
    type: CLEAR_MANPOWER_PERFORMANCE_SUCCESS
  };
};

export const getResource = () => {
  return async dispatch => {
    dispatch(fetchStart());

    try {
      const {manpowerPerformance} = store.getState();
      const {query} = manpowerPerformance;
      const response = await axios.get(
        `/manpower-performance?${generateQueryString(query)}`
      );

      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  };
};

export const getResourceForDownload = (columns, filters, name) => {
  return async dispatch => {
    dispatch(fetchStart());

    try {
      const {manpowerPerformance} = store.getState();
      const {query} = manpowerPerformance;
      const response = await axios.get(
        `/manpower-performance/download?columns=${columns}&${generateQueryString(
          query
        )}`
      );
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns);
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  };
};

export const getJobCardStatusByActivityId = jobCards => {
  return async dispatch => {
    dispatch(fetchStart());

    try {
      var queryString = Object.keys(jobCards)
        .map(key => key + "=" + jobCards[key])
        .join("&");
      const response = await axios.get(
        `/job-card/job-card-status-by-activity?${queryString}`
      );
      dispatch(fetchSuccess());
      dispatch(getJobCardStatusByActivityIdSuccess(response));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  };
};

export const getJobCardByLocation = location => {
  return async dispatch => {
    dispatch(fetchStart());

    try {
      const response = await axios.get(
        `/activity/job-card-by-location?location=${location}`
      );
      dispatch(fetchSuccess());
      dispatch(getJobCardByLocationSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  };
};

export const createResource = payload => {
  return async dispatch => {
    dispatch(fetchStart());
    try {
      const formData = new FormData();
      formData.append('name', 'Jay');
      const documentData = [];
      payload.documents && payload.documents.length && payload.documents.map((item, index) => {
        formData.append('files', item.file);
        let data = {...item};
        delete data.file;
        documentData.push(data)
      });
      formData.append('documentData', JSON.stringify(documentData));
      Object.keys(payload).forEach(key => {
        if(key !== 'documents') {
          if(key === 'maintenance')
            formData.append(key, JSON.stringify(payload[key]));
          else
            formData.append(key, payload[key]);
        }
      });
      const response = await axios.post(`/manpower-performance`, formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}});
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({data: response.data}));
      history.push("/manpower-performance");
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  };
};

export const updateResource = (payload, id, jobCardIDForBackToJC) => {
  return async dispatch => {
    dispatch(fetchStart());
    try {
      let formData = new FormData();
      const documentData = [];
      const documentIds = [];
      payload.documents && payload.documents.length && payload.documents.map((item, index) => {
        if(!item.file.path) {
          formData.append('files', item.file);
          let data = {...item};
          delete data.file;
          documentData.push(data)
        } else {
          documentIds.push(item._id);
        }
      });
      formData.append('documentData', JSON.stringify(documentData));
      formData.append('documentIds', JSON.stringify(documentIds));
      Object.keys(payload).forEach(key => {
        if(key !== 'documents') {
          if(key === 'maintenance')
            formData.append(key, JSON.stringify(payload[key]));
          else
            formData.append(key, payload[key]);
        }
      });
      await axios.put(`/manpower-performance/${id}`, formData, {config: {headers: {'Content-Type': 'multipart/form-data'}}});
      if(jobCardIDForBackToJC) {
        history.push(`/job-card/report/${jobCardIDForBackToJC}`);
      } else {
        dispatch(fetchSuccess());
        dispatch(getUser());
        history.push("/manpower-performance");
        dispatch(getResource());
      }
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  };
};

export const fetchResource = id => {
  return async dispatch => {
    dispatch(fetchStart());

    try {
      const response = await axios.get(`/manpower-performance/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  };
};

export const deleteResource = id => {
  return async dispatch => {
    dispatch(fetchStart());

    try {
      const response = await axios.delete(`/manpower-performance/${id}`);
      if(response && response.data && response.data.message) {
        message.error(response.data.message);
      }
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  };
};

export const fetchReportDataSuccess = ({data}) => {
  return {
    type: FETCH_MANPOWER_PERFORMANCE_REPORT_DATA_SUCCESS,
    data
  };
};

export const clearReportData = () => {
  return {
    type: CLEAR_MANPOWER_PERFORMANCE_REPORT_DATA
  };
};

export const getReport = payload => {
  return async dispatch => {
    dispatch(fetchStart);

    try {
      const response = await axios.post(
        `/manpower-performance/report/`,
        payload
      );
      dispatch(fetchSuccess());
      dispatch(fetchReportDataSuccess(response));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  };
};
